import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { Route, Routes, Navigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import IdleTimer from "react-idle-timer";
import { logoutAct, validateJwtTokenExpiry } from "../../Actions/authActions";
import TimeoutModal from "../../Pages/Dashboard/TimeoutPopup";
import config from "../../config";
import {
  eventUrl,
  subDomain,
} from "../../utils";


let logoutTimer = null;

function ProtectedRoute({ children }) {

  const isAuthenticated = useSelector(
    (state) => state.auth.isAuthenticated
  );
  const user = JSON.parse(localStorage.getItem("user")) || {};
  const dispatch = useDispatch();
  const idleTimer = useRef();
  const subdomain = subDomain();
  const [showModal, setShowModal] = useState(false);
  // SECURITY FIX: Track if subdomain validation passed
  const [isSubdomainValid, setIsSubdomainValid] = useState(true);

  const MINUTE_MS = 60000;//0;

  // SECURITY FIX: Verify payer is on their correct subdomain
  useEffect(() => {
    const currentSubdomain = subDomain();

    // Check if user exists and has a subdomain
    if (user && user.subdomain && currentSubdomain) {
      // If user's subdomain doesn't match current subdomain, they shouldn't have access
      if (user.subdomain !== currentSubdomain) {
        console.error('SECURITY: Payer subdomain mismatch - clearing credentials');
        localStorage.removeItem('user');
        localStorage.removeItem('token');
        setIsSubdomainValid(false);
        // Redirect to their correct subdomain
        window.location.href = `https://${user.subdomain}.sosoftpay.com/login`;
      }
    }
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      dispatch(validateJwtTokenExpiry(subdomain));//code runs every 10 minutes
    }, MINUTE_MS);
    return () => clearInterval(interval); // This represents the unmount function, in which you need to clear our interval to prevent memory leaks.
  }, [])

  const onIdleFunc = () => {
    setShowModal(!showModal);
    logoutTimer = setTimeout(() => {
      dispatch(logoutAct(false, subdomain));
    }, 170400000);
  };

  const redirect = () => {
    window.location.href = `${eventUrl(subdomain)}login`;
  }

  const handleStayLoggedIn = () => {
    if (logoutTimer) {
      clearTimeout(logoutTimer);
      logoutTimer = null;
    }
    idleTimer.current.reset();
    setShowModal(!showModal);
  };

  // SECURITY FIX: If subdomain validation failed, show nothing (redirect is in progress)
  if (!isSubdomainValid) {
    return null;
  }

  return (
    <>
      <IdleTimer
        ref={idleTimer}
        element={document}
        stopOnIdle={true}
        onIdle={onIdleFunc}
        timeout={parseInt(config.USER_INACTIVE)}
      />
      <TimeoutModal
        openModal={showModal}
        onCloseModal={setShowModal}
        handleStayLoggedIn={handleStayLoggedIn}
      />

            { (user && Object.keys(user).length > 0 && isSubdomainValid) ? (
              children
            ) : (
             // <Navigate to={`${subdomain}/login`} replace />
             redirect()
            )
        }

    </>
  );
}



export default ProtectedRoute;

